import confetti from "canvas-confetti";

/* Celebration engine for the order-success screen:
   1. A happy ascending chime (Web Audio — no audio files needed)
   2. Party-popper confetti in OmniMist brand colours
   Everything fails silently on unsupported browsers — the success screen must never break. */

const BRAND_COLORS = ["#7C9885", "#D4AF37", "#F3E9D2", "#2B2B2B"];

const playChime = () => {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    if (ctx.state === "suspended") ctx.resume().catch(() => {});
    const notes = [523.25, 659.25, 783.99, 1046.5]; // C5 · E5 · G5 · C6
    notes.forEach((freq, i) => {
      const t = ctx.currentTime + i * 0.13;
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(0.16, t + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.55);
      osc.connect(gain).connect(ctx.destination);
      osc.start(t);
      osc.stop(t + 0.6);
    });
  } catch {
    /* stay silent */
  }
};

export const partyPopper = () => {
  try {
    confetti({
      particleCount: 90,
      spread: 75,
      startVelocity: 42,
      origin: { y: 0.6 },
      colors: BRAND_COLORS,
      zIndex: 200,
    });
    setTimeout(() => {
      confetti({ particleCount: 60, angle: 60, spread: 60, origin: { x: 0, y: 0.7 }, colors: BRAND_COLORS, zIndex: 200 });
    }, 250);
    setTimeout(() => {
      confetti({ particleCount: 60, angle: 120, spread: 60, origin: { x: 1, y: 0.7 }, colors: BRAND_COLORS, zIndex: 200 });
    }, 400);
  } catch {
    /* stay silent */
  }
};

export const celebrateOrder = () => {
  playChime();
  partyPopper();
};
